export const UNICODE = {
  WORD_JOINER: '&#8288;',
};
